// extracted by mini-css-extract-plugin
export default {"wrapper":"GC-z","addressLine":"HC-z","fullName":"IC-z"};